<template>
    <div>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Indicadores financieros</h4>
        </div>
        <card v-if="!agro" class="form-horizontal">
            <div class="card-header"></div>
            <div class="card-body">
                <el-table :data="data" ref="productsTable">
                    <el-table-column label="Indicador" property="name"></el-table-column>
                    <el-table-column label="Valor">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.value)}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="card-footer"></div>
        </card>
        <div class="row">
            <div v-for="stats in statsCards" :key="stats.id" class="col-lg-4 col-md-6 col-sm-12">
                <stats-card :type="stats.type"
                            :icon="stats.icon"
                            :small-title="stats.title"
                            :title="setFormatWithoutSymbol(stats.value)">
                </stats-card>
            </div>
        </div>
        <div v-if="!agro" class="row">
            <div  v-for="stats in percentCards" :key="stats.id" class="col-lg-4 col-md-6 col-sm-12">
                <circle-chart-card :percentage="stats.value"
                                :chart-id="stats.id"
                                :title="stats.title"
                                color="#F09500">
                </circle-chart-card>
            </div>
        </div>
        <div v-if="!agro" class="row">
            <div v-for="stats in statsCards2" :key="stats.id" class="col-lg-4 col-md-6 col-sm-12">
                <stats-card :type="stats.type"
                            :icon="stats.icon"
                            :small-title="stats.title"
                            :title="setFormatWithPercent(stats.value)">
                </stats-card>
            </div>
        </div>
        <div class="text-right">
            <p-button @click="toFinish()" type="warning">Siguiente</p-button>
            <p-button @click="toCharacterAnalysisChart()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import VueScrollTo from 'vue-scrollto'
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import StatsCard from 'src/components/UIComponents/Cards/StatsCard'
    import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Select, Option, Table, TableColumn} from 'element-ui'
    import CharacterAnalysis from 'src/util/CharacterAnalysis/CharacterAnalysis'
    import PProgress from 'src/components/UIComponents/Progress.vue'
    import moment from 'moment'
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
    export default {
        components: {
            Card,
            StatsCard,
            CircleChartCard,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal,
            PProgress,
        },
        data() {
        return {
            consumer: false,
            microcredit: false,
            pyme: false,
            agro: false,
            customerPyme: false,
            customerAgro: false,
            statsCards: [
                {
                    id: 1,
                    type: 'warning',
                    icon: 'nc-icon nc-money-coins',
                    title: 'Liquidez corriente',
                    value: 0,
                    footerText: 'Updated now',
                    footerIcon: 'nc-icon nc-refresh-69'
                },
                {
                    id: 2,
                    type: 'warning',
                    icon: 'nc-icon nc-refresh-69',
                    title: 'Rotación inventario',
                    value: 0,
                    footerText: 'Last day',
                    footerIcon: 'nc-icon nc-calendar-60'
                }                
            ],
            statsCards2: [
                {
                    id: 1,
                    type: 'warning',
                    icon: 'nc-icon nc-money-coins',
                    title: 'Cobertura de la cuota',
                    value: 0,
                    footerText: 'Updated now',
                    footerIcon: 'nc-icon nc-refresh-69'
                }                              
            ],
            statsCards3: [
                {
                    id: 1,
                    type: 'warning',
                    icon: 'nc-icon nc-money-coins',
                    title: 'índice de endeudamiento',
                    value: 0,
                    footerText: 'Updated now',
                    footerIcon: 'nc-icon nc-refresh-69'
                },
                {
                    id: 2,
                    type: 'warning',
                    icon: 'nc-icon nc-money-coins',
                    title: 'Capacidad de pago acumulada',
                    value: 0,
                    footerText: 'Updated now',
                    footerIcon: 'nc-icon nc-refresh-69'
                }                              
            ],
            percentCards: [
                {
                    value: 0,
                    id: 'endeudamiento',
                    title: 'Endeudamiento',
                },
                {
                    value: 0,
                    id: 'rentabilidad_negocio',
                    title: 'Rentabilidad del negocio',
                },
                {
                    value: 0,
                    id: 'rentabilidad_patrimonio',
                    title: 'Rentabilidad patrimonio',
                },
            ],
            data: [
                {
                    name: 'Ingresos por ventas al contado',
                    value: 0,
                },
                {
                    name: 'Costo de ventas',
                    value: 0,
                },
                {
                    name: 'Utilidad neta',
                    value: 0,
                },
                {
                    name: 'Capacidad de pago',
                    value: 0,
                },
            ],
            categories: [],
            modelValidations: {
                statement : {
                    required: true
                }
            },
        }
        },
        watch: {

        },
        computed: {
        },
        methods: {
            validateAgroSpouse () {
                var vm = this;
                if (vm.$store.state.isSpouse) {
                    var firstProduct = vm.$store.getters.getProductTypes.find(product => product.id == vm.$store.state.assesments[vm.$store.state.actualAssesment].customer.studies[0].productType)
                    if(firstProduct.name.toLowerCase() == 'agropecuario'){
                        let netProfit = vm.$store.state.assesments[vm.$store.state.actualAssesment].customerSpouse.studies[0].balance[0].er.net_profit;
                        let clientTerm =  vm.$store.state.assesments[vm.$store.state.actualAssesment].customer.studies[0].agroData.cashFlow.clientTerm || 0;
                        let totalNetProfit = (parseFloat(netProfit) * parseFloat(clientTerm)) || 0;
                        let spouseBalance = {
                            spouseName: 'Cónyuge Micro',
                            spouseValue : netProfit,
                            spouseTotal : totalNetProfit
                        }
                        vm.$store.dispatch('setSpouseBalance', spouseBalance).then(()=>{
                            console.log('Datos almacenados correctamente');
                        });
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             productValidator (product) {
                if (product.name.toLowerCase() == 'consumo') {
                    this.consumer = true;
                    this.microcredit = false;
                    this.pyme = false;
                    this.agro = false;
                }
                else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                    this.microcredit = true;
                    this.consumer = false;
                    this.pyme = false;
                    this.agro = false;
                }
                else if (product.name.toLowerCase() == 'pequeña empresa') {
                    this.microcredit = false;
                    this.consumer = false;
                    this.agro = false;
                    this.pyme = true;
                    if(this.$store.state.isCustomer){
                        this.customerPyme = true;
                        this.customerAgro = false;
                    }
                }
                else if (product.name.toLowerCase() == 'agropecuario') {
                    this.microcredit = false;
                    this.consumer = false;
                    this.pyme = false;
                    this.agro = true;
                    if(this.$store.state.isCustomer){
                        this.customerAgro = true;
                        this.customerPyme = false;
                    }
                }
                else {
                    // this.showNotificationError('Este tipo de producto aún no es implementado en EMI');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toBalance () {
                this.$router.push('/asessments/new_asessment/customer/others/additional_information');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormatWithoutSymbol (value) {
                return formatMoney(value, { symbol: "", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormatWithPercent (value) {
                return formatMoney(value, { symbol: "%", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toOperatingExpenses () {
                this.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toCharacterAnalysisChart () {
                if (this.agro) {
                    this.$router.push('/asessments/new_asessment/customer/agro/cash_flow');
                }
                else {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy == 0) {
                        this.$router.push('/asessments/new_asessment/customer/others/character_analysis_chart');
                    }
                    else {
                        this.$router.push('/asessments/new_asessment/customer/others/additional_information');
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toFinish () {
                var vm = this;
                // if(vm.$store.state.assesments[vm.$store.state.actualAssesment].hasOwnProperty('created_at') == true) {
                //     vm.$store.state.assesments[vm.$store.state.actualAssesment].created_at = moment().format(); 
                // }
                if (vm.$store.state.isCustomer) {
                    if(!vm.pyme && !vm.agro){
                        swal({
                            title: '¿Deseas agregar otro estudio?',
                            text: 'Si aceptas, iniciarás otro estudio para el mismo cliente',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Si, aceptar',
                            cancelButtonText: 'No, continuar',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            cancelButtonClass: 'btn btn-danger btn-fill',
                            buttonsStyling: false
                        }).then(() => {
                            vm.$store.dispatch('newStudy', 'customer').then(()=>{
                                vm.$router.push('/asessments/new_asessment/customer/request_data');
                            });
                            
                        }, function (dismiss) {
                                // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                if (dismiss == 'cancel') {
                                    if (vm.$store.state.assesments[vm.$store.state.actualAssesment].customer.actualStudy == 0) {
                                        if (vm.$store.state.assesments[vm.$store.state.actualAssesment].guarantors.length > 0 && vm.$store.state.assesments[vm.$store.state.actualAssesment].guarantors[0].studies.length > 0) {
                                            swal({
                                                title: 'Codeudor encontrado',
                                                // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                text: 'Hemos encontrado que agregaste un codeudor, puedes ir al menú o continuar el flujo',
                                                type: 'warning',
                                                showCancelButton: true,
                                                confirmButtonText: 'Si, ir al menú',
                                                cancelButtonText: 'No, continuar',
                                                confirmButtonClass: 'btn btn-success btn-fill',
                                                cancelButtonClass: 'btn btn-danger btn-fill',
                                                buttonsStyling: false
                                            }).then(() => {
                                                vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                    vm.$store.dispatch('setActualAssesment', vm.$store.state.syncAssessment).then(()=>{
                                                        vm.$router.push('/asessments/menu');
                                                    });
                                                });
                                                
                                            }, function (dismiss) {
                                                // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                if (dismiss == 'cancel') {
                                                    swal({
                                                    title: '¿Deseas agregar un estudio del cónyuge del titular?',
                                                    text: 'Si aceptas, agregarás o editarás el cónyuge al titular de la evaluación',
                                                    type: 'warning',
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Si, aceptar',
                                                    cancelButtonText: 'No, continuar',
                                                    confirmButtonClass: 'btn btn-success btn-fill',
                                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                                    buttonsStyling: false
                                                }).then(() => {
                                                    vm.$store.dispatch('newSpouse').then(()=>{
                                                        vm.$router.push('/asessments/new_asessment/customer/personal_data');
                                                    });
                                                    
                                                }, function (dismiss) {
                                                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                    if (dismiss == 'cancel') {
                                                        swal({
                                                            title: '¿Deseas agregar información al FM102?',
                                                            // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                            text: 'Si aceptas, agregarás o editarás información del formulario FM102',
                                                            type: 'warning',
                                                            showCancelButton: true,
                                                            confirmButtonText: 'Si, aceptar',
                                                            cancelButtonText: 'No, continuar',
                                                            confirmButtonClass: 'btn btn-success btn-fill',
                                                            cancelButtonClass: 'btn btn-danger btn-fill',
                                                            buttonsStyling: false
                                                        }).then(() => {
                                                            var payload = {
                                                                client: 'customer',
                                                                actualAssesment: vm.$store.state.actualAssesment,
                                                                actualStudy: 0
                                                            }
                                                            var payload2 = {
                                                                stage: 'Finalización',
                                                                description: 'Se finaliza la evaluación.',
                                                                dateTime: moment().format()
                                                            };
                                                            vm.$store.dispatch('setChangeLog', payload2).then(()=>{
                                                                vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                                    vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                                                                        vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                                                                            vm.$router.push('/asessments/new_asessment/customer/fm102');
                                                                        });                    
                                                                    });
                                                                });
                                                            });
                                                            
                                                        }, function (dismiss) {
                                                            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                            var payload = {
                                                                stage: 'Finalización',
                                                                description: 'Se finaliza la evaluación.',
                                                                dateTime: moment().format()
                                                            };
                                                            vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                                                vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                                        vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync'); 
                                                                });
                                                            });
                                                        })
                                                    }
                                                    else {
                                                        swal({
                                                            title: 'Cancelado',
                                                            text: 'El analista no ha finalizado',
                                                            type: 'error',
                                                            confirmButtonClass: 'btn btn-info btn-fill',
                                                            buttonsStyling: false
                                                        })
                                                    }
                                                })
                                                }
                                                else {
                                                    swal({
                                                        title: 'Cancelado',
                                                        text: 'El analista no ha continuado',
                                                        type: 'error',
                                                        confirmButtonClass: 'btn btn-info btn-fill',
                                                        buttonsStyling: false
                                                    })
                                                }
                                            })
                                            // vm.$router.push('/asessments/menu');
                                        }
                                        else {
                                                swal({
                                                    title: '¿Deseas agregar un estudio del cónyuge del titular?',
                                                    text: 'Si aceptas, agregarás o editarás el cónyuge al titular de la evaluación',
                                                    type: 'warning',
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Si, aceptar',
                                                    cancelButtonText: 'No, continuar',
                                                    confirmButtonClass: 'btn btn-success btn-fill',
                                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                                    buttonsStyling: false
                                                }).then(() => {
                                                    vm.$store.dispatch('newSpouse').then(()=>{
                                                        vm.$router.push('/asessments/new_asessment/customer/personal_data');
                                                    });
                                                    
                                                }, function (dismiss) {
                                                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                    if (dismiss == 'cancel') {
                                                        swal({
                                                            title: '¿Deseas agregar un codeudor?',
                                                            // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                            text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                            type: 'warning',
                                                            showCancelButton: true,
                                                            confirmButtonText: 'Si, aceptar',
                                                            cancelButtonText: 'No, continuar',
                                                            confirmButtonClass: 'btn btn-success btn-fill',
                                                            cancelButtonClass: 'btn btn-danger btn-fill',
                                                            buttonsStyling: false
                                                        }).then(() => {
                                                            vm.$store.dispatch('newGuarantor').then(()=>{
                                                                vm.$router.push('/asessments/new_asessment/customer/personal_data');
                                                            });
                                                            
                                                        }, function (dismiss) {
                                                            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                            if (dismiss == 'cancel') {
                                                                swal({
                                                                    title: '¿Deseas agregar información al FM102?',
                                                                    // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                                    text: 'Si aceptas, agregarás o editarás información del formulario FM102',
                                                                    type: 'warning',
                                                                    showCancelButton: true,
                                                                    confirmButtonText: 'Si, aceptar',
                                                                    cancelButtonText: 'No, continuar',
                                                                    confirmButtonClass: 'btn btn-success btn-fill',
                                                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                                                    buttonsStyling: false
                                                                }).then(() => {
                                                                    var payload = {
                                                                        client: 'customer',
                                                                        actualAssesment: vm.$store.state.actualAssesment,
                                                                        actualStudy: 0
                                                                    }
                                                                    var payload2 = {
                                                                        stage: 'Finalización',
                                                                        description: 'Se finaliza la evaluación.',
                                                                        dateTime: moment().format()
                                                                    };
                                                                    vm.$store.dispatch('setChangeLog', payload2).then(()=>{
                                                                        vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                                            vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                                                                                vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                                                                                    vm.$router.push('/asessments/new_asessment/customer/fm102');
                                                                                });                    
                                                                            });
                                                                        });
                                                                    });
                                                                    
                                                                }, function (dismiss) {
                                                                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                                    var payload = {
                                                                        stage: 'Finalización',
                                                                        description: 'Se finaliza la evaluación.',
                                                                        dateTime: moment().format()
                                                                    };
                                                                    vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                                                        vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                                                vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync'); 
                                                                        });
                                                                    });
                                                                })
                                                            }
                                                            else {
                                                                swal({
                                                                    title: 'Cancelado',
                                                                    text: 'El analista no ha finalizado',
                                                                    type: 'error',
                                                                    confirmButtonClass: 'btn btn-info btn-fill',
                                                                    buttonsStyling: false
                                                                })
                                                            }
                                                        })
                                                    }
                                                    else {
                                                        swal({
                                                            title: 'Cancelado',
                                                            text: 'El analista no ha finalizado',
                                                            type: 'error',
                                                            confirmButtonClass: 'btn btn-info btn-fill',
                                                            buttonsStyling: false
                                                        })
                                                    }
                                                })
                                        }
                                    }
                                    else {
                                        var payload = {
                                            client: 'customer',
                                            actualAssesment: vm.$store.state.actualAssesment,
                                            actualStudy: 0
                                        }
                                        vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                            vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                                                vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                                                    vm.$router.push('/asessments/new_asessment/customer/others/additional_information_consolidated');
                                                });                    
                                            });
                                        });
                                    }
                                }
                                else {
                                    swal({
                                        title: 'Cancelado',
                                        text: 'El analista no ha finalizado',
                                        type: 'error',
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        buttonsStyling: false
                                    })
                                }
                            })
                    }
                    else if(vm.pyme) {
                        swal({
                            title: '¿Deseas agregar otro estudio?',
                            text: 'Si aceptas, iniciarás otro estudio para el mismo cliente',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Si, aceptar',
                            cancelButtonText: 'No, continuar',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            cancelButtonClass: 'btn btn-danger btn-fill',
                            buttonsStyling: false
                        }).then(() => {
                            vm.$store.dispatch('newStudy', 'customer').then(()=>{
                                vm.$router.push('/asessments/new_asessment/customer/request_data');
                            });
                            
                        }, function (dismiss) {
                                // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                if (dismiss == 'cancel') {
                                    if (vm.$store.state.assesments[vm.$store.state.actualAssesment].customer.actualStudy == 0) {
                                        if (vm.$store.state.assesments[vm.$store.state.actualAssesment].guarantors.length > 0 && vm.$store.state.assesments[vm.$store.state.actualAssesment].guarantors[0].studies.length > 0) {
                                            swal({
                                                title: 'Codeudor encontrado',
                                                // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                text: 'Hemos encontrado que agregaste un codeudor, puedes ir al menú o continuar el flujo',
                                                type: 'warning',
                                                showCancelButton: true,
                                                confirmButtonText: 'Si, ir al menú',
                                                cancelButtonText: 'No, continuar',
                                                confirmButtonClass: 'btn btn-success btn-fill',
                                                cancelButtonClass: 'btn btn-danger btn-fill',
                                                buttonsStyling: false
                                            }).then(() => {
                                                vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                    vm.$store.dispatch('setActualAssesment', vm.$store.state.syncAssessment).then(()=>{
                                                        vm.$router.push('/asessments/menu');
                                                    });
                                                });
                                                
                                            }, function (dismiss) {
                                                // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                if (dismiss == 'cancel') {
                                                    swal({
                                                    title: '¿Deseas agregar un estudio del cónyuge del titular?',
                                                    text: 'Si aceptas, agregarás o editarás el cónyuge al titular de la evaluación',
                                                    type: 'warning',
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Si, aceptar',
                                                    cancelButtonText: 'No, continuar',
                                                    confirmButtonClass: 'btn btn-success btn-fill',
                                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                                    buttonsStyling: false
                                                }).then(() => {
                                                    vm.$store.dispatch('newSpouse').then(()=>{
                                                        vm.$router.push('/asessments/new_asessment/customer/personal_data');
                                                    });
                                                    
                                                }, function (dismiss) {
                                                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                    if (dismiss == 'cancel') {
                                                        swal({
                                                            title: '¿Deseas agregar evaluación cualitativa y de riesgo al flujo de crédito?',
                                                            // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                            text: 'Si aceptas, agregarás o editarás evaluación cualitativa y de riesgo al flujo de crédito',
                                                            type: 'warning',
                                                            showCancelButton: true,
                                                            confirmButtonText: 'Si, aceptar',
                                                            cancelButtonText: 'No, continuar',
                                                            confirmButtonClass: 'btn btn-success btn-fill',
                                                            cancelButtonClass: 'btn btn-danger btn-fill',
                                                            buttonsStyling: false
                                                        }).then(() => {
                                                            vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                                vm.$store.dispatch('setActualAssesment', vm.$store.state.syncAssessment).then(()=>{
                                                                    vm.$router.push('/asessments/new_asessment/customer/others/willingness_to_pay'); 
                                                                });
                                                            });
                                                            
                                                        }, function (dismiss) {
                                                            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                            if (dismiss == 'cancel') {
                                                                swal({
                                                                    title: '¿Deseas agregar información al FM102?',
                                                                    // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                                    text: 'Si aceptas, agregarás o editarás información del formulario FM102',
                                                                    type: 'warning',
                                                                    showCancelButton: true,
                                                                    confirmButtonText: 'Si, aceptar',
                                                                    cancelButtonText: 'No, continuar',
                                                                    confirmButtonClass: 'btn btn-success btn-fill',
                                                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                                                    buttonsStyling: false
                                                                }).then(() => {
                                                                    var payload = {
                                                                        client: 'customer',
                                                                        actualAssesment: vm.$store.state.actualAssesment,
                                                                        actualStudy: 0
                                                                    }
                                                                    var payload2 = {
                                                                        stage: 'Finalización',
                                                                        description: 'Se finaliza la evaluación.',
                                                                        dateTime: moment().format()
                                                                    };
                                                                    vm.$store.dispatch('setChangeLog', payload2).then(()=>{
                                                                        vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                                            vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                                                                                vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                                                                                    vm.$router.push('/asessments/new_asessment/customer/fm102');
                                                                                });                    
                                                                            });
                                                                        });
                                                                    });
                                                                    
                                                                }, function (dismiss) {
                                                                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                                    var payload = {
                                                                        stage: 'Finalización',
                                                                        description: 'Se finaliza la evaluación.',
                                                                        dateTime: moment().format()
                                                                    };
                                                                    vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                                                        vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                                                vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync'); 
                                                                        });
                                                                    });
                                                                })
                                                            }
                                                            else {
                                                                swal({
                                                                    title: 'Cancelado',
                                                                    text: 'El analista no ha finalizado',
                                                                    type: 'error',
                                                                    confirmButtonClass: 'btn btn-info btn-fill',
                                                                    buttonsStyling: false
                                                                })
                                                            }
                                                        })
                                                    }
                                                    else {
                                                        swal({
                                                            title: 'Cancelado',
                                                            text: 'El analista no ha finalizado',
                                                            type: 'error',
                                                            confirmButtonClass: 'btn btn-info btn-fill',
                                                            buttonsStyling: false
                                                        })
                                                    }
                                                })
                                                }
                                                else {
                                                    swal({
                                                        title: 'Cancelado',
                                                        text: 'El analista no ha continuado',
                                                        type: 'error',
                                                        confirmButtonClass: 'btn btn-info btn-fill',
                                                        buttonsStyling: false
                                                    })
                                                }
                                            })
                                            // vm.$router.push('/asessments/menu');
                                        }
                                        else {
                                                swal({
                                                    title: '¿Deseas agregar un estudio del cónyuge del titular?',
                                                    text: 'Si aceptas, agregarás o editarás el cónyuge al titular de la evaluación',
                                                    type: 'warning',
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Si, aceptar',
                                                    cancelButtonText: 'No, continuar',
                                                    confirmButtonClass: 'btn btn-success btn-fill',
                                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                                    buttonsStyling: false
                                                }).then(() => {
                                                    vm.$store.dispatch('newSpouse').then(()=>{
                                                        vm.$router.push('/asessments/new_asessment/customer/personal_data');
                                                    });
                                                    
                                                }, function (dismiss) {
                                                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                    if (dismiss == 'cancel') {
                                                        swal({
                                                            title: '¿Deseas agregar un codeudor?',
                                                            // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                            text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                            type: 'warning',
                                                            showCancelButton: true,
                                                            confirmButtonText: 'Si, aceptar',
                                                            cancelButtonText: 'No, continuar',
                                                            confirmButtonClass: 'btn btn-success btn-fill',
                                                            cancelButtonClass: 'btn btn-danger btn-fill',
                                                            buttonsStyling: false
                                                        }).then(() => {
                                                            vm.$store.dispatch('newGuarantor').then(()=>{
                                                                vm.$router.push('/asessments/new_asessment/customer/personal_data');
                                                            });
                                                            
                                                        }, function (dismiss) {
                                                            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                            if (dismiss == 'cancel') {
                                                                swal({
                                                                    title: '¿Deseas agregar evaluación cualitativa y de riesgo al flujo de crédito?',
                                                                    // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                                    text: 'Si aceptas, agregarás o editarás evaluación cualitativa y de riesgo al flujo de crédito',
                                                                    type: 'warning',
                                                                    showCancelButton: true,
                                                                    confirmButtonText: 'Si, aceptar',
                                                                    cancelButtonText: 'No, continuar',
                                                                    confirmButtonClass: 'btn btn-success btn-fill',
                                                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                                                    buttonsStyling: false
                                                                }).then(() => {
                                                                    vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                                        vm.$store.dispatch('setActualAssesment', vm.$store.state.syncAssessment).then(()=>{
                                                                            vm.$router.push('/asessments/new_asessment/customer/others/willingness_to_pay'); 
                                                                        });
                                                                    });
                                                                    
                                                                }, function (dismiss) {
                                                                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                                    if (dismiss == 'cancel') {
                                                                        swal({
                                                                            title: '¿Deseas agregar información al FM102?',
                                                                            // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                                            text: 'Si aceptas, agregarás o editarás información del formulario FM102',
                                                                            type: 'warning',
                                                                            showCancelButton: true,
                                                                            confirmButtonText: 'Si, aceptar',
                                                                            cancelButtonText: 'No, continuar',
                                                                            confirmButtonClass: 'btn btn-success btn-fill',
                                                                            cancelButtonClass: 'btn btn-danger btn-fill',
                                                                            buttonsStyling: false
                                                                        }).then(() => {
                                                                            var payload = {
                                                                                client: 'customer',
                                                                                actualAssesment: vm.$store.state.actualAssesment,
                                                                                actualStudy: 0
                                                                            }
                                                                            var payload2 = {
                                                                                stage: 'Finalización',
                                                                                description: 'Se finaliza la evaluación.',
                                                                                dateTime: moment().format()
                                                                            };
                                                                            vm.$store.dispatch('setChangeLog', payload2).then(()=>{
                                                                                vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                                                    vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                                                                                        vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                                                                                            vm.$router.push('/asessments/new_asessment/customer/fm102');
                                                                                        });                    
                                                                                    });
                                                                                });
                                                                            });
                                                                            
                                                                        }, function (dismiss) {
                                                                            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                                            var payload = {
                                                                                stage: 'Finalización',
                                                                                description: 'Se finaliza la evaluación.',
                                                                                dateTime: moment().format()
                                                                            };
                                                                            vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                                                                vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                                                        vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync'); 
                                                                                });
                                                                            });
                                                                        })
                                                                    }
                                                                    else {
                                                                        swal({
                                                                            title: 'Cancelado',
                                                                            text: 'El analista no ha finalizado',
                                                                            type: 'error',
                                                                            confirmButtonClass: 'btn btn-info btn-fill',
                                                                            buttonsStyling: false
                                                                        })
                                                                    }
                                                                })
                                                            }
                                                            else {
                                                                swal({
                                                                    title: 'Cancelado',
                                                                    text: 'El analista no ha finalizado',
                                                                    type: 'error',
                                                                    confirmButtonClass: 'btn btn-info btn-fill',
                                                                    buttonsStyling: false
                                                                })
                                                            }
                                                        })
                                                    }
                                                    else {
                                                        swal({
                                                            title: 'Cancelado',
                                                            text: 'El analista no ha finalizado',
                                                            type: 'error',
                                                            confirmButtonClass: 'btn btn-info btn-fill',
                                                            buttonsStyling: false
                                                        })
                                                    }
                                                })
                                        }
                                    }
                                    else {
                                        var payload = {
                                            client: 'customer',
                                            actualAssesment: vm.$store.state.actualAssesment,
                                            actualStudy: 0
                                        }
                                        vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                            vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                                                vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                                                    vm.$router.push('/asessments/new_asessment/customer/others/additional_information_consolidated');
                                                });                    
                                            });
                                        });
                                    }
                                }
                                else {
                                    swal({
                                        title: 'Cancelado',
                                        text: 'El analista no ha finalizado',
                                        type: 'error',
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        buttonsStyling: false
                                    })
                                }
                            })
                    }
                    else if(vm.agro){
                        if (vm.$store.state.assesments[vm.$store.state.actualAssesment].customer.actualStudy == 0) {
                            if (vm.$store.state.assesments[vm.$store.state.actualAssesment].guarantors.length > 0 && vm.$store.state.assesments[vm.$store.state.actualAssesment].guarantors[0].studies.length > 0) {
                                swal({
                                    title: 'Codeudor encontrado',
                                    // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                    text: 'Hemos encontrado que agregaste un codeudor, puedes ir al menú o continuar el flujo',
                                    type: 'warning',
                                    showCancelButton: true,
                                    confirmButtonText: 'Si, ir al menú',
                                    cancelButtonText: 'No, continuar',
                                    confirmButtonClass: 'btn btn-success btn-fill',
                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                    buttonsStyling: false
                                }).then(() => {
                                    vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                        vm.$store.dispatch('setActualAssesment', vm.$store.state.syncAssessment).then(()=>{
                                            vm.$router.push('/asessments/menu');
                                        });
                                    });
                                    
                                }, function (dismiss) {
                                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                    if (dismiss == 'cancel') {
                                        swal({
                                        title: '¿Deseas agregar un estudio del cónyuge del titular?',
                                        text: 'Si aceptas, agregarás o editarás el cónyuge al titular de la evaluación',
                                        type: 'warning',
                                        showCancelButton: true,
                                        confirmButtonText: 'Si, aceptar',
                                        cancelButtonText: 'No, continuar',
                                        confirmButtonClass: 'btn btn-success btn-fill',
                                        cancelButtonClass: 'btn btn-danger btn-fill',
                                        buttonsStyling: false
                                    }).then(() => {
                                        vm.$store.dispatch('newSpouse').then(()=>{
                                            vm.$router.push('/asessments/new_asessment/customer/personal_data');
                                        });
                                        
                                    }, function (dismiss) {
                                        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                        if (dismiss == 'cancel') {
                                            swal({
                                                title: '¿Deseas agregar información al FM102?',
                                                // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                text: 'Si aceptas, agregarás o editarás información del formulario FM102',
                                                type: 'warning',
                                                showCancelButton: true,
                                                confirmButtonText: 'Si, aceptar',
                                                cancelButtonText: 'No, continuar',
                                                confirmButtonClass: 'btn btn-success btn-fill',
                                                cancelButtonClass: 'btn btn-danger btn-fill',
                                                buttonsStyling: false
                                            }).then(() => {
                                                var payload = {
                                                    client: 'customer',
                                                    actualAssesment: vm.$store.state.actualAssesment,
                                                    actualStudy: 0
                                                }
                                                var payload2 = {
                                                    stage: 'Finalización',
                                                    description: 'Se finaliza la evaluación.',
                                                    dateTime: moment().format()
                                                };
                                                vm.$store.dispatch('setChangeLog', payload2).then(()=>{
                                                    vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                        vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                                                            vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                                                                vm.$router.push('/asessments/new_asessment/customer/fm102');
                                                            });                    
                                                        });
                                                    });
                                                });
                                                
                                            }, function (dismiss) {
                                                // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                var payload = {
                                                    stage: 'Finalización',
                                                    description: 'Se finaliza la evaluación.',
                                                    dateTime: moment().format()
                                                };
                                                vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                                    vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                            vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync'); 
                                                    });
                                                });
                                            })
                                        }
                                        else {
                                            swal({
                                                title: 'Cancelado',
                                                text: 'El analista no ha finalizado',
                                                type: 'error',
                                                confirmButtonClass: 'btn btn-info btn-fill',
                                                buttonsStyling: false
                                            })
                                        }
                                    })
                                    }
                                    else {
                                        swal({
                                            title: 'Cancelado',
                                            text: 'El analista no ha continuado',
                                            type: 'error',
                                            confirmButtonClass: 'btn btn-info btn-fill',
                                            buttonsStyling: false
                                        })
                                    }
                                })
                                // vm.$router.push('/asessments/menu');
                            }
                            else {
                                    swal({
                                        title: '¿Deseas agregar un estudio del cónyuge del titular?',
                                        text: 'Si aceptas, agregarás o editarás el cónyuge al titular de la evaluación',
                                        type: 'warning',
                                        showCancelButton: true,
                                        confirmButtonText: 'Si, aceptar',
                                        cancelButtonText: 'No, continuar',
                                        confirmButtonClass: 'btn btn-success btn-fill',
                                        cancelButtonClass: 'btn btn-danger btn-fill',
                                        buttonsStyling: false
                                    }).then(() => {
                                        vm.$store.dispatch('newSpouse').then(()=>{
                                            vm.$router.push('/asessments/new_asessment/customer/personal_data');
                                        });
                                        
                                    }, function (dismiss) {
                                        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                        if (dismiss == 'cancel') {
                                            swal({
                                                title: '¿Deseas agregar un codeudor?',
                                                // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                type: 'warning',
                                                showCancelButton: true,
                                                confirmButtonText: 'Si, aceptar',
                                                cancelButtonText: 'No, continuar',
                                                confirmButtonClass: 'btn btn-success btn-fill',
                                                cancelButtonClass: 'btn btn-danger btn-fill',
                                                buttonsStyling: false
                                            }).then(() => {
                                                vm.$store.dispatch('newGuarantor').then(()=>{
                                                    vm.$router.push('/asessments/new_asessment/customer/personal_data');
                                                });
                                                
                                            }, function (dismiss) {
                                                // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                if (dismiss == 'cancel') {
                                                    swal({
                                                        title: '¿Deseas agregar información al FM102?',
                                                        // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                        text: 'Si aceptas, agregarás o editarás información del formulario FM102',
                                                        type: 'warning',
                                                        showCancelButton: true,
                                                        confirmButtonText: 'Si, aceptar',
                                                        cancelButtonText: 'No, continuar',
                                                        confirmButtonClass: 'btn btn-success btn-fill',
                                                        cancelButtonClass: 'btn btn-danger btn-fill',
                                                        buttonsStyling: false
                                                    }).then(() => {
                                                        var payload = {
                                                            client: 'customer',
                                                            actualAssesment: vm.$store.state.actualAssesment,
                                                            actualStudy: 0
                                                        }
                                                        var payload2 = {
                                                            stage: 'Finalización',
                                                            description: 'Se finaliza la evaluación.',
                                                            dateTime: moment().format()
                                                        };
                                                        vm.$store.dispatch('setChangeLog', payload2).then(()=>{
                                                            vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                                vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                                                                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                                                                        vm.$router.push('/asessments/new_asessment/customer/fm102');
                                                                    });                    
                                                                });
                                                            });
                                                        });
                                                        
                                                    }, function (dismiss) {
                                                        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                        var payload = {
                                                            stage: 'Finalización',
                                                            description: 'Se finaliza la evaluación.',
                                                            dateTime: moment().format()
                                                        };
                                                        vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                                            vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                                    vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync'); 
                                                            });
                                                        });
                                                    })
                                                }
                                                else {
                                                    swal({
                                                        title: 'Cancelado',
                                                        text: 'El analista no ha finalizado',
                                                        type: 'error',
                                                        confirmButtonClass: 'btn btn-info btn-fill',
                                                        buttonsStyling: false
                                                    })
                                                }
                                            })
                                        }
                                        else {
                                            swal({
                                                title: 'Cancelado',
                                                text: 'El analista no ha finalizado',
                                                type: 'error',
                                                confirmButtonClass: 'btn btn-info btn-fill',
                                                buttonsStyling: false
                                            })
                                        }
                                    })
                            }
                        }
                        else {
                            var payload = {
                                client: 'customer',
                                actualAssesment: vm.$store.state.actualAssesment,
                                actualStudy: 0
                            }
                            vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                                        vm.$router.push('/asessments/new_asessment/customer/others/additional_information_consolidated');
                                    });                    
                                });
                            });
                        }
                        
                        
                    }
                }
                else if (vm.$store.state.isSpouse) {
                    this.validateAgroSpouse();
                    if (vm.$store.state.assesments[vm.$store.state.actualAssesment].guarantors.length > 0 && vm.$store.state.assesments[vm.$store.state.actualAssesment].guarantors[0].studies.length > 0) {
                        swal({
                            title: 'Codeudor encontrado',
                            // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                            text: 'Hemos encontrado que agregaste un codeudor, puedes ir al menú o continuar el flujo',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Si, ir al menú',
                            cancelButtonText: 'No, continuar',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            cancelButtonClass: 'btn btn-danger btn-fill',
                            buttonsStyling: false
                        }).then(() => {
                            vm.$store.dispatch('finishEvaluation', 'spouse').then(()=>{
                                vm.$store.dispatch('setActualAssesment', vm.$store.state.syncAssessment).then(()=>{
                                    vm.$router.push('/asessments/menu');
                                });
                            });
                            
                        }, function (dismiss) {
                            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                            if (dismiss == 'cancel') {
                                if(vm.pyme || vm.customerPyme){
                                    swal({
                                        title: '¿Deseas agregar evaluación cualitativa y de riesgo al flujo de crédito?',
                                        // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                        text: 'Si aceptas, agregarás o editarás evaluación cualitativa y de riesgo al flujo de crédito',
                                        type: 'warning',
                                        showCancelButton: true,
                                        confirmButtonText: 'Si, aceptar',
                                        cancelButtonText: 'No, continuar',
                                        confirmButtonClass: 'btn btn-success btn-fill',
                                        cancelButtonClass: 'btn btn-danger btn-fill',
                                        buttonsStyling: false
                                    }).then(() => {
                                        vm.$store.dispatch('finishEvaluation', 'spouse').then(()=>{
                                            vm.$store.dispatch('setActualAssesment', vm.$store.state.syncAssessment).then(()=>{
                                                vm.$router.push('/asessments/new_asessment/customer/others/willingness_to_pay'); 
                                            });
                                        });
                                    }, function (dismiss) {
                                        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                        if (dismiss == 'cancel') {
                                            swal({
                                                title: '¿Deseas agregar información al FM102?',
                                                // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                text: 'Si aceptas, agregarás o editarás información del formulario FM102',
                                                type: 'warning',
                                                showCancelButton: true,
                                                confirmButtonText: 'Si, aceptar',
                                                cancelButtonText: 'No, continuar',
                                                confirmButtonClass: 'btn btn-success btn-fill',
                                                cancelButtonClass: 'btn btn-danger btn-fill',
                                                buttonsStyling: false
                                            }).then(() => {
                                                var payload = {
                                                    client: 'customer',
                                                    actualAssesment: vm.$store.state.actualAssesment,
                                                    actualStudy: 0
                                                }
                                                var payload2 = {
                                                    stage: 'Finalización',
                                                    description: 'Se finaliza la evaluación del cónyuge.',
                                                    dateTime: moment().format()
                                                };
                                                vm.$store.dispatch('setChangeLog', payload2).then(()=>{
                                                    vm.$store.dispatch('finishEvaluation', 'spouse').then(()=>{
                                                        vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                                                            vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                                                                vm.$router.push('/asessments/new_asessment/customer/fm102');
                                                            });                    
                                                        });
                                                    });
                                                });
                                                
                                            }, function (dismiss) {
                                                // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                var payload = {
                                                    stage: 'Finalización',
                                                    description: 'Se finaliza la evaluación.',
                                                    dateTime: moment().format()
                                                };
                                                vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                                    vm.$store.dispatch('finishEvaluation', 'spouse').then(()=>{
                                                            vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync'); 
                                                    });
                                                });
                                            })
                                        }
                                        else {
                                            swal({
                                                title: 'Cancelado',
                                                text: 'El analista no ha finalizado',
                                                type: 'error',
                                                confirmButtonClass: 'btn btn-info btn-fill',
                                                buttonsStyling: false
                                            })
                                        }
                                    })
                                }
                                else {
                                    swal({
                                        title: '¿Deseas agregar información al FM102?',
                                        // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                        text: 'Si aceptas, agregarás o editarás información del formulario FM102',
                                        type: 'warning',
                                        showCancelButton: true,
                                        confirmButtonText: 'Si, aceptar',
                                        cancelButtonText: 'No, continuar',
                                        confirmButtonClass: 'btn btn-success btn-fill',
                                        cancelButtonClass: 'btn btn-danger btn-fill',
                                        buttonsStyling: false
                                    }).then(() => {
                                        var payload2 = {
                                            stage: 'Finalización',
                                            description: 'Se finaliza la evaluación del cónyuge.',
                                            dateTime: moment().format()
                                        };
                                        vm.$store.dispatch('setChangeLog', payload2).then(()=>{
                                            vm.$store.dispatch('finishEvaluation', 'spouse').then(()=>{
                                                vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                                                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                                                        vm.$router.push('/asessments/new_asessment/customer/fm102');
                                                    });                    
                                                });
                                            });
                                        });
                                        
                                    }, function (dismiss) {
                                        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                        var payload = {
                                            stage: 'Finalización',
                                            description: 'Se finaliza la evaluación del cónyuge.',
                                            dateTime: moment().format()
                                        };
                                        vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                            vm.$store.dispatch('finishEvaluation', 'spouse').then(()=>{
                                                vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync'); 
                                            });
                                        });
                                    })
                                }
                            }
                            else {
                                swal({
                                    title: 'Cancelado',
                                    text: 'El analista no ha continuado',
                                    type: 'error',
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    buttonsStyling: false
                                })
                            }
                        })
                    }
                    else {
                        swal({
                            title: '¿Deseas agregar un codeudor?',
                            // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                            text: 'Si aceptas, agregarás un codeudor a la evaluación',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Si, aceptar',
                            cancelButtonText: 'No, continuar',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            cancelButtonClass: 'btn btn-danger btn-fill',
                            buttonsStyling: false
                        }).then(() => {
                            var payload2 = {
                                stage: 'Finalización',
                                description: 'Se finaliza la evaluación del cónyuge.',
                                dateTime: moment().format()
                            };
                            vm.$store.dispatch('setChangeLog', payload2).then(()=>{
                                vm.$store.dispatch('finishEvaluationRedirectTo', 'spouse').then(()=>{
                                    vm.$store.dispatch('newGuarantor').then(()=>{
                                        vm.$router.push('/asessments/new_asessment/customer/personal_data');
                                    });
                                });
                            });
                            
                        }, function (dismiss) {
                            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                            if (dismiss == 'cancel') {
                                if(vm.pyme || vm.customerPyme){
                                    swal({
                                        title: '¿Deseas agregar evaluación cualitativa y de riesgo al flujo de crédito?',
                                        // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                        text: 'Si aceptas, agregarás o editarás evaluación cualitativa y de riesgo al flujo de crédito',
                                        type: 'warning',
                                        showCancelButton: true,
                                        confirmButtonText: 'Si, aceptar',
                                        cancelButtonText: 'No, continuar',
                                        confirmButtonClass: 'btn btn-success btn-fill',
                                        cancelButtonClass: 'btn btn-danger btn-fill',
                                        buttonsStyling: false
                                    }).then(() => {
                                        vm.$store.dispatch('finishEvaluation', 'spouse').then(()=>{
                                            vm.$store.dispatch('setActualAssesment', vm.$store.state.syncAssessment).then(()=>{
                                                vm.$router.push('/asessments/new_asessment/customer/others/willingness_to_pay'); 
                                            });
                                        });
                                    }, function (dismiss) {
                                        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                        if (dismiss == 'cancel') {
                                            swal({
                                                title: '¿Deseas agregar información al FM102?',
                                                // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                text: 'Si aceptas, agregarás o editarás información del formulario FM102',
                                                type: 'warning',
                                                showCancelButton: true,
                                                confirmButtonText: 'Si, aceptar',
                                                cancelButtonText: 'No, continuar',
                                                confirmButtonClass: 'btn btn-success btn-fill',
                                                cancelButtonClass: 'btn btn-danger btn-fill',
                                                buttonsStyling: false
                                            }).then(() => {
                                                var payload = {
                                                    client: 'customer',
                                                    actualAssesment: vm.$store.state.actualAssesment,
                                                    actualStudy: 0
                                                }
                                                var payload2 = {
                                                    stage: 'Finalización',
                                                    description: 'Se finaliza la evaluación del cónyuge.',
                                                    dateTime: moment().format()
                                                };
                                                vm.$store.dispatch('setChangeLog', payload2).then(()=>{
                                                    vm.$store.dispatch('finishEvaluation', 'spouse').then(()=>{
                                                        vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                                                            vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                                                                vm.$router.push('/asessments/new_asessment/customer/fm102');
                                                            });                    
                                                        });
                                                    });
                                                });
                                                
                                            }, function (dismiss) {
                                                // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                var payload = {
                                                    stage: 'Finalización',
                                                    description: 'Se finaliza la evaluación.',
                                                    dateTime: moment().format()
                                                };
                                                vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                                    vm.$store.dispatch('finishEvaluation', 'spouse').then(()=>{
                                                            vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync'); 
                                                    });
                                                });
                                            })
                                        }
                                        else {
                                            swal({
                                                title: 'Cancelado',
                                                text: 'El analista no ha finalizado',
                                                type: 'error',
                                                confirmButtonClass: 'btn btn-info btn-fill',
                                                buttonsStyling: false
                                            })
                                        }
                                    })
                                }
                                else {
                                    swal({
                                        title: '¿Deseas agregar información al FM102?',
                                        // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                        text: 'Si aceptas, agregarás o editarás información del formulario FM102',
                                        type: 'warning',
                                        showCancelButton: true,
                                        confirmButtonText: 'Si, aceptar',
                                        cancelButtonText: 'No, continuar',
                                        confirmButtonClass: 'btn btn-success btn-fill',
                                        cancelButtonClass: 'btn btn-danger btn-fill',
                                        buttonsStyling: false
                                    }).then(() => {
                                        var payload = {
                                            client: 'customer',
                                            actualAssesment: vm.$store.state.actualAssesment,
                                            actualStudy: 0
                                        }
                                        var payload2 = {
                                            stage: 'Finalización',
                                            description: 'Se finaliza la evaluación.',
                                            dateTime: moment().format()
                                        };
                                        vm.$store.dispatch('setChangeLog', payload2).then(()=>{
                                            vm.$store.dispatch('finishEvaluation', 'spouse').then(()=>{
                                                vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                                                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                                                        vm.$router.push('/asessments/new_asessment/customer/fm102');
                                                    });                    
                                                });
                                            });
                                        });
                                        
                                    }, function (dismiss) {
                                        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                        var payload = {
                                            stage: 'Finalización',
                                            description: 'Se finaliza la evaluación.',
                                            dateTime: moment().format()
                                        };
                                        vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                            vm.$store.dispatch('finishEvaluation', 'spouse').then(()=>{
                                                vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync'); 
                                            });
                                        });
                                    })
                                }
                            }
                            else {
                                swal({
                                    title: 'Cancelado',
                                    text: 'El analista no ha finalizado',
                                    type: 'error',
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    buttonsStyling: false
                                })
                            }
                        })
                    }
                }
                if (vm.$store.state.isGuarantor) {
                    if(vm.pyme || vm.customerPyme){
                        swal({
                            title: '¿Deseas agregar evaluación cualitativa y de riesgo al flujo de crédito?',
                            // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                            text: 'Si aceptas, agregarás o editarás evaluación cualitativa y de riesgo al flujo de crédito',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Si, aceptar',
                            cancelButtonText: 'No, continuar',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            cancelButtonClass: 'btn btn-danger btn-fill',
                            buttonsStyling: false
                        }).then(() => {
                            vm.$store.dispatch('finishEvaluation', 'guarantor').then(()=>{
                                vm.$store.dispatch('setActualAssesment', vm.$store.state.syncAssessment).then(()=>{
                                    vm.$router.push('/asessments/new_asessment/customer/others/willingness_to_pay'); 
                                });
                            });
                        }, function (dismiss) {
                            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                            if (dismiss == 'cancel') {
                                swal({
                                    title: '¿Deseas agregar información al FM102?',
                                    // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                    text: 'Si aceptas, agregarás o editarás información del formulario FM102',
                                    type: 'warning',
                                    showCancelButton: true,
                                    confirmButtonText: 'Si, aceptar',
                                    cancelButtonText: 'No, continuar',
                                    confirmButtonClass: 'btn btn-success btn-fill',
                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                    buttonsStyling: false
                                }).then(() => {
                                    var payload = {
                                        client: 'customer',
                                        actualAssesment: vm.$store.state.actualAssesment,
                                        actualStudy: 0
                                    }
                                    var payload2 = {
                                        stage: 'Finalización',
                                        description: 'Se finaliza la evaluación del cónyuge.',
                                        dateTime: moment().format()
                                    };
                                    vm.$store.dispatch('setChangeLog', payload2).then(()=>{
                                        vm.$store.dispatch('finishEvaluation', 'guarantor').then(()=>{
                                            vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                                                vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                                                    vm.$router.push('/asessments/new_asessment/customer/fm102');
                                                });                    
                                            });
                                        });
                                    });
                                    
                                }, function (dismiss) {
                                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                    var payload = {
                                        stage: 'Finalización',
                                        description: 'Se finaliza la evaluación.',
                                        dateTime: moment().format()
                                    };
                                    vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                        vm.$store.dispatch('finishEvaluation', 'guarantor').then(()=>{
                                                vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync'); 
                                        });
                                    });
                                })
                            }
                            else {
                                swal({
                                    title: 'Cancelado',
                                    text: 'El analista no ha finalizado',
                                    type: 'error',
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    buttonsStyling: false
                                })
                            }
                        })
                    }
                    else {
                        swal({
                            title: '¿Deseas agregar información al FM102?',
                            // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                            text: 'Si aceptas, agregarás o editarás información del formulario FM102',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Si, aceptar',
                            cancelButtonText: 'No, continuar',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            cancelButtonClass: 'btn btn-danger btn-fill',
                            buttonsStyling: false
                        }).then(() => {
                            var payload = {
                                client: 'customer',
                                actualAssesment: vm.$store.state.actualAssesment,
                                actualStudy: 0
                            }
                            var payload2 = {
                                stage: 'Finalización',
                                description: 'Se finaliza la evaluación.',
                                dateTime: moment().format()
                            };
                            vm.$store.dispatch('setChangeLog', payload2).then(()=>{
                                vm.$store.dispatch('finishEvaluation', 'guarantor').then(()=>{
                                    vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                                        vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                                            vm.$router.push('/asessments/new_asessment/customer/fm102');
                                        });                    
                                    });
                                });
                            });
                            
                        }, function (dismiss) {
                            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                            var payload = {
                                stage: 'Finalización',
                                description: 'Se finaliza la evaluación.',
                                dateTime: moment().format()
                            };
                            vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                vm.$store.dispatch('finishEvaluation', 'guarantor').then(()=>{
                                        vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync'); 
                                });
                            });
                        })
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            saveReferences () {
                if (this.products.length != 0) {
                    this.$store.dispatch('setReferences', this.products).then(()=>{
                        this.$router.push('/asessments/new_asessment/customer/others/additional_information');
                    });
                }
                else {
                    this.$router.push('/asessments/new_asessment/customer/others/additional_information');
                }
            }
        },
        mounted () {
            if(this.$store.state.isCustomer) {
                var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].productType)
                this.productValidator(product);
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales != 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance.length != 0 && !this.agro) {
                    var storageFinancialIndicators = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0].i.financialIndicators;
                    var storagePaymentCapacity = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0].cp.paymentCapacity;
                    this.data[0].value = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0].er.account_sales;
                    this.data[1].value = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0].er.sales_costs;
                    this.data[2].value = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0].er.net_profit;
                    if(!this.pyme && !this.agro) {
                        for (let i=0;i<storageFinancialIndicators.length;i++) {
                            if(storageFinancialIndicators[i].name == 'Liquidez corriente') {
                                this.statsCards[0].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Rotación Inventario') {
                                this.statsCards[1].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Endeudamiento') {
                                this.percentCards[0].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Rentabilidad Negocio') {
                                this.percentCards[1].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Rentabilidad Patrimonio') {
                                this.percentCards[2].value = storageFinancialIndicators[i].value || 0;
                            } 
                            else if(storageFinancialIndicators[i].name == 'Cobertura de la cuota') {
                                this.statsCards2[0].value = storageFinancialIndicators[i].value || 0;
                            }    
                        }
                    }
                    else if(this.pyme){
                        this.statsCards2 =  [
                            {
                                id: 1,
                                type: 'warning',
                                icon: 'nc-icon nc-money-coins',
                                title: 'Cobertura de la cuota',
                                value: 0,
                                footerText: 'Updated now',
                                footerIcon: 'nc-icon nc-refresh-69'
                            },
                            {
                                id: 2,
                                type: 'warning',
                                icon: 'nc-icon nc-money-coins',
                                title: 'Apalancamiento',
                                value: 0,
                                footerText: 'Updated now',
                                footerIcon: 'nc-icon nc-refresh-69'
                            },
                            {
                                id: 3,
                                type: 'warning',
                                icon: 'nc-icon nc-money-coins',
                                title: 'Margen de ventas',
                                value: 0,
                                footerText: 'Updated now',
                                footerIcon: 'nc-icon nc-refresh-69'
                            },                               
                        ]
                        for (let i=0;i<storageFinancialIndicators.length;i++) {
                            if(storageFinancialIndicators[i].name == 'Liquidez corriente') {
                                this.statsCards[0].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Rotación Inventario') {
                                this.statsCards[1].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Endeudamiento') {
                                this.percentCards[0].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Rentabilidad Negocio') {
                                this.percentCards[1].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Rentabilidad Patrimonio') {
                                this.percentCards[2].value = storageFinancialIndicators[i].value || 0;
                            } 
                            else if(storageFinancialIndicators[i].name == 'Cobertura de la cuota') {
                                this.statsCards2[0].value = storageFinancialIndicators[i].value || 0;
                            }    
                            else if(storageFinancialIndicators[i].name == 'Apalancamiento') {
                                this.statsCards2[1].value = storageFinancialIndicators[i].value || 0;
                            }    
                            else if(storageFinancialIndicators[i].name == 'Margen de ventas') {
                                this.statsCards2[2].value = storageFinancialIndicators[i].value || 0;
                            }    
                        }
                    }
                    for (let i=0;i<storagePaymentCapacity.length;i++) {
                        if(!this.pyme){
                            if(storagePaymentCapacity[i].name == 'Capacidad de pago (60%)') {
                                this.data[3].value = storagePaymentCapacity[i].value || 0;
                            }  
                        }
                        else if(this.pyme){
                            if(storagePaymentCapacity[i].name == 'Capacidad de pago (75%)') {
                                this.data[3].value = storagePaymentCapacity[i].value || 0;
                            }
                        }
                    }
                }
                else if(this.agro) {
                    this.statsCards = this.statsCards3;
                    var storageFinancialIndicators = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0].i.financialIndicators;
                    for (let i=0;i<storageFinancialIndicators.length;i++) {
                        const name = storageFinancialIndicators[i].name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                        if(name == 'indice de endeudamiento') {
                            this.statsCards[0].value = storageFinancialIndicators[i].value || 0;
                        }
                        else if(name == 'capacidad de pago acumulada') {
                            this.statsCards[1].value = storageFinancialIndicators[i].value || 0;
                        }  
                    }
                }
            }
            if(this.$store.state.isSpouse) {
                var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].productType)
                this.productValidator(product);
                if(!this.pyme){
                    return
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales != 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].balance.length != 0) {
                    var storageFinancialIndicators = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].balance[0].i.financialIndicators;
                    var storagePaymentCapacity = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].balance[0].cp.paymentCapacity;
                    this.data[0].value = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].balance[0].er.account_sales;
                    this.data[1].value = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].balance[0].er.sales_costs;
                    this.data[2].value = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].balance[0].er.net_profit;
                    if(!this.pyme) {
                        for (let i=0;i<storageFinancialIndicators.length;i++) {
                            if(storageFinancialIndicators[i].name == 'Liquidez corriente') {
                                this.statsCards[0].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Rotación Inventario') {
                                this.statsCards[1].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Endeudamiento') {
                                this.percentCards[0].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Rentabilidad Negocio') {
                                this.percentCards[1].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Rentabilidad Patrimonio') {
                                this.percentCards[2].value = storageFinancialIndicators[i].value || 0;
                            } 
                            else if(storageFinancialIndicators[i].name == 'Cobertura de la cuota') {
                                this.statsCards2[0].value = storageFinancialIndicators[i].value || 0;
                            }    
                        }
                    }
                    else if(this.pyme){
                        this.statsCards2 =  [
                            {
                                id: 1,
                                type: 'warning',
                                icon: 'nc-icon nc-money-coins',
                                title: 'Cobertura de la cuota',
                                value: 0,
                                footerText: 'Updated now',
                                footerIcon: 'nc-icon nc-refresh-69'
                            },
                            {
                                id: 2,
                                type: 'warning',
                                icon: 'nc-icon nc-money-coins',
                                title: 'Apalancamiento',
                                value: 0,
                                footerText: 'Updated now',
                                footerIcon: 'nc-icon nc-refresh-69'
                            },
                            {
                                id: 3,
                                type: 'warning',
                                icon: 'nc-icon nc-money-coins',
                                title: 'Margen de ventas',
                                value: 0,
                                footerText: 'Updated now',
                                footerIcon: 'nc-icon nc-refresh-69'
                            },                               
                        ]
                        for (let i=0;i<storageFinancialIndicators.length;i++) {
                            if(storageFinancialIndicators[i].name == 'Liquidez corriente') {
                                this.statsCards[0].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Rotación Inventario') {
                                this.statsCards[1].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Endeudamiento') {
                                this.percentCards[0].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Rentabilidad Negocio') {
                                this.percentCards[1].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Rentabilidad Patrimonio') {
                                this.percentCards[2].value = storageFinancialIndicators[i].value || 0;
                            } 
                            else if(storageFinancialIndicators[i].name == 'Cobertura de la cuota') {
                                this.statsCards2[0].value = storageFinancialIndicators[i].value || 0;
                            }    
                            else if(storageFinancialIndicators[i].name == 'Apalancamiento') {
                                this.statsCards2[1].value = storageFinancialIndicators[i].value || 0;
                            }    
                            else if(storageFinancialIndicators[i].name == 'Margen de ventas') {
                                this.statsCards2[2].value = storageFinancialIndicators[i].value || 0;
                            }    
                        }
                    }
                    for (let i=0;i<storagePaymentCapacity.length;i++) {
                        if(!this.pyme){
                            if(storagePaymentCapacity[i].name == 'Capacidad de pago (60%)') {
                                this.data[3].value = storagePaymentCapacity[i].value || 0;
                            }  
                        }
                        else if(this.pyme){
                            if(storagePaymentCapacity[i].name == 'Capacidad de pago (75%)') {
                                this.data[3].value = storagePaymentCapacity[i].value || 0;
                            }
                        }
                    }
                }
                else if(this.agro) {
                    console.log(this.agro);
                    this.statsCards = this.statsCards3;
                }
            }
            else if(this.$store.state.isGuarantor) {
                var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].productType)
                this.productValidator(product);
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales != 0 && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance.length != 0) {
                    var storageFinancialIndicators = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance[0].i.financialIndicators;
                    var storagePaymentCapacity = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance[0].cp.paymentCapacity;
                    this.data[0].value = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance[0].er.account_sales;
                    this.data[1].value = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance[0].er.sales_costs;
                    this.data[2].value = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance[0].er.net_profit;
                    if(!this.pyme) {
                        for (let i=0;i<storageFinancialIndicators.length;i++) {
                            if(storageFinancialIndicators[i].name == 'Liquidez corriente') {
                                this.statsCards[0].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Rotación Inventario') {
                                this.statsCards[1].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Endeudamiento') {
                                this.percentCards[0].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Rentabilidad Negocio') {
                                this.percentCards[1].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Rentabilidad Patrimonio') {
                                this.percentCards[2].value = storageFinancialIndicators[i].value || 0;
                            } 
                            else if(storageFinancialIndicators[i].name == 'Cobertura de la cuota') {
                                this.statsCards2[0].value = storageFinancialIndicators[i].value || 0;
                            }    
                        }
                    }
                    else if(this.pyme){
                        this.statsCards2 =  [
                            {
                                id: 1,
                                type: 'warning',
                                icon: 'nc-icon nc-money-coins',
                                title: 'Cobertura de la cuota',
                                value: 0,
                                footerText: 'Updated now',
                                footerIcon: 'nc-icon nc-refresh-69'
                            },
                            {
                                id: 2,
                                type: 'warning',
                                icon: 'nc-icon nc-money-coins',
                                title: 'Apalancamiento',
                                value: 0,
                                footerText: 'Updated now',
                                footerIcon: 'nc-icon nc-refresh-69'
                            },
                            {
                                id: 3,
                                type: 'warning',
                                icon: 'nc-icon nc-money-coins',
                                title: 'Margen de ventas',
                                value: 0,
                                footerText: 'Updated now',
                                footerIcon: 'nc-icon nc-refresh-69'
                            },                               
                        ]
                        for (let i=0;i<storageFinancialIndicators.length;i++) {
                            if(storageFinancialIndicators[i].name == 'Liquidez corriente') {
                                this.statsCards[0].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Rotación Inventario') {
                                this.statsCards[1].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Endeudamiento') {
                                this.percentCards[0].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Rentabilidad Negocio') {
                                this.percentCards[1].value = storageFinancialIndicators[i].value || 0;
                            }
                            else if(storageFinancialIndicators[i].name == 'Rentabilidad Patrimonio') {
                                this.percentCards[2].value = storageFinancialIndicators[i].value || 0;
                            } 
                            else if(storageFinancialIndicators[i].name == 'Cobertura de la cuota') {
                                this.statsCards2[0].value = storageFinancialIndicators[i].value || 0;
                            }    
                            else if(storageFinancialIndicators[i].name == 'Apalancamiento') {
                                this.statsCards2[1].value = storageFinancialIndicators[i].value || 0;
                            }    
                            else if(storageFinancialIndicators[i].name == 'Margen de ventas') {
                                this.statsCards2[2].value = storageFinancialIndicators[i].value || 0;
                            }    
                        }
                    }
                    for (let i=0;i<storagePaymentCapacity.length;i++) {
                        if(!this.pyme){
                            if(storagePaymentCapacity[i].name == 'Capacidad de pago (60%)') {
                                this.data[3].value = storagePaymentCapacity[i].value || 0;
                            }  
                        }
                        else if(this.pyme){
                            if(storagePaymentCapacity[i].name == 'Capacidad de pago (75%)') {
                                this.data[3].value = storagePaymentCapacity[i].value || 0;
                            }
                        }
                    }
                }
                else if(this.agro) {
                    this.statsCards = this.statsCards3;
                    var storageFinancialIndicators = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance[0].i.financialIndicators;
                    for (let i=0;i<storageFinancialIndicators.length;i++) {
                        const name = storageFinancialIndicators[i].name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                        if(name == 'indice de endeudamiento') {
                            this.statsCards[0].value = storageFinancialIndicators[i].value || 0;
                        }
                        else if(name == 'capacidad de pago acumulada') {
                            this.statsCards[1].value = storageFinancialIndicators[i].value || 0;
                        }  
                    }
                }
            }            
        }
    }
</script>
<style lang="scss">
// Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
    .card-content{
        min-height: 85px
    }
</style>
